import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, map } from 'rxjs';
import type { EmployeeMeResponse, EmployeeDto, EmployeeByIdResponse } from 'src/app/api-client';

const apiUrl = environment.CalystaApiBaseURL;

interface LocalEmployee {
  Employee: EmployeeMeResponse;
  oid: string;
  expirationDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  url = apiUrl + 'api/employee';

  private _employee = new BehaviorSubject<EmployeeMeResponse | null>(null);

  constructor(private http: HttpClient) {
    const localEmployee: LocalEmployee = JSON.parse(
      localStorage.getItem('employee')
    );

    if (
      localEmployee?.Employee?.Email &&
      localEmployee.Employee.Email.length > 0 &&
      new Date(localEmployee?.expirationDate) > new Date()
    ) {
      this._employee.next(localEmployee.Employee);
    }
  }

  public getEmployeeName(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/Lookup`);
  }

  getUrl() {
    return this.url;
  }

  getMyself(): Observable<EmployeeMeResponse> {
    return this.http.get<EmployeeMeResponse>(`${this.url}/Me`);
  }

  hasEmployeeInLocalStore(): boolean {
    return this._employee.getValue() != null;
  }

  getEmployee(): Observable<EmployeeMeResponse | null> {
    if (this._employee.getValue() == null) {
      this.loadEmployee();
    }
    return this._employee.asObservable();
  }

  getEmployeeById(EmployeeId: number): Observable<EmployeeDto> {
    const params = new HttpParams().set('Id', EmployeeId.toString());
    return this.http
      .get<EmployeeByIdResponse>(`${this.url}/GetById`, { params })
      .pipe(map((data) => data.Employee!));
  }

  getLookup(ActiveOnly?: boolean): Observable<EmployeeDto[]> {
    return this.http
      .get<{ data: EmployeeDto[] }>(`${this.url}/Lookup?ActiveOnly=${ActiveOnly}`)
      .pipe(map((data) => data.data ?? []));
  }

  loadEmployee() {
    this.getMyself().subscribe((employee) => {
      this._employee.next(employee);

      const localEmployee: LocalEmployee = {
        Employee: employee,
        oid: String(employee.EmployeeId ?? ''),
        expirationDate: new Date(
          new Date().getTime() + 7 * 24 * 60 * 60 * 1000
        ).toISOString(),
      };
      localStorage.setItem('employee', JSON.stringify(localEmployee));
    });
  }
}
